import { createFileRoute } from "@tanstack/react-router"
import { CreateVaultEntry } from "modules/settings/components/KeysAndSecrets/CreateVaultEntry"

export const Route = createFileRoute("/_base/_auth/settings/keys-and-secrets/vault/create")({
  component: CreateVaultEntry,
})
